import React, { useMemo } from 'react';

import MerchantSelect from '@components/operator/MerchantSelect';
import OrderTemplatesEdit from '@components/shared/order_templates/OrderTemplatesEdit';
import { useOperatorData } from '@contexts/operator/OperatorDataContext';
import { useOperatorOrderTemplateService } from '@hooks/operator/order_templates/useOperatorOrderTemplateService';

function NewContent() {
  const service = useOperatorOrderTemplateService();
  const { merchantSalesChannels } = useOperatorData();

  // 與 operator Edit.tsx 對齊：把 context 內的 sales channels 轉成下拉選項。
  // 新增頁原本漏傳 salesChannels，導致「適用通路」永遠 No data。
  const salesChannelOptions = useMemo(() => {
    return (merchantSalesChannels ?? []).map((channel) => ({
      label: channel.name || channel.extra_name || '',
      value: channel.id,
      ...channel,
    }));
  }, [merchantSalesChannels]);

  return (
    <OrderTemplatesEdit
      role="operator"
      service={service}
      salesChannels={salesChannelOptions}
    />
  );
}

export default function OperatorOrderTemplateNew() {
  return (
    <MerchantSelect>
      <NewContent />
    </MerchantSelect>
  );
}
